<template>
  <span>
    <v-menu v-model="showMenu" :close-on-content-click="false" :nudge-width="300" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-2"
          color="grey lighten-4"
          data-cy="loadFilterPresetButton"
          elevation="0"
          small
          v-bind="attrs"
          v-on="on"
        >
          {{ buttonText }}
          <v-icon class="ml-2" color="grey" small>fas fa-caret-down</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-text class="pb-2">
          <v-text-field dense hide-details outlined placeholder="Search saved filters..." v-model="filterPresetSearch">
            <template v-slot:prepend-inner>
              <v-icon class="mr-2 mt-1" color="grey" small>fas fa-search</v-icon>
            </template>
          </v-text-field>

          <div class="mt-3 pl-2">
            <label class="caption">Saved Filters ({{ presetList.length }})</label>
          </div>
          <v-card outlined max-height="500">
            <v-data-table
              :headers="headers"
              :items="presetList"
              :search="filterPresetSearch"
              dense
              disable-pagination
              disable-sort
              hide-default-footer
              hide-default-header
            >
              <template v-slot:item="{ item }">
                <tr class="filterPresetRow">
                  <td class="pointer" @click="loadPreset(item)">
                    {{ item.name }}
                  </td>
                  <td class="text-right">
                    <v-btn
                      :data-cy="`deleteFilterPresetButton_${item.name}`"
                      @click="showDeleteDialog(item)"
                      color="grey"
                      icon
                      small
                    >
                      <v-icon x-small>fas fa-trash-alt</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-divider class="mt-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showMenu = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-dialog v-model="deleteDialog" persistent max-width="500" v-if="presetToDelete">
      <v-card>
        <v-card-title class="text-h5 font-weight-thin">
          Delete Saved Filter
        </v-card-title>
        <v-divider class="mb-3"></v-divider>
        <v-card-text>
          Are you sure you'd like to delete the saved filter '<b>{{ presetToDelete.name }}</b
          >'?

          <v-card outlined color="grey lighten-3" class="mt-3">
            <v-card-text class="px-6">
              <filter-list :filterList="presetToDelete.filterList"></filter-list>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="pb-3 px-6">
          <v-spacer></v-spacer>
          <v-btn text @click="closeDeleteDialog">
            Cancel
          </v-btn>
          <v-btn color="primary" data-cy="confirmFilterPresetDeleteButton" elevation="0" @click="deletePreset">
            Yes, Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FilterList from "./FilterList.vue";

export default {
  components: {
    FilterList,
  },
  computed: {
    quickFilterList: {
      get() {
        return this.$store.state.quickFilter.list;
      },
      async set(value) {
        await this.$store.dispatch("quickFilter/update", value);
      },
    },
  },
  data() {
    return {
      deleteDialog: false,
      filterPresetSearch: null,
      headers: [{ text: "Name", value: "name" }],
      presetToDelete: null,
      showMenu: false,
    };
  },
  methods: {
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.presetToDelete = null;
    },
    closeMenu() {
      this.showMenu = false;
    },
    async deletePresetFromQuickFilters(presetName) {
      const updatedQuickFilterList = this.quickFilterList.filter(quickFilter => quickFilter.presetName !== presetName);

      if (updatedQuickFilterList.length <= this.quickFilterList.length) {
        this.quickFilterList = updatedQuickFilterList;
      }
    },
    async deletePreset() {
      if (!this.presetToDelete || !this.presetToDelete.name) {
        return;
      }

      const presetName = this.presetToDelete.name;

      try {
        await this.deleteFilterPreset(presetName);
        await this.deletePresetFromQuickFilters(presetName);
        this.$notifySuccess({
          title: "Success",
          message: `Filter preset '${presetName}' deleted.`,
        });
      } catch (e) {
        console.error(e);
        this.$notifyError({
          title: "Error",
          message: `Failed to delete filter preset '${presetName}'.`,
        });
      }

      this.presetToDelete = null;
      this.deleteDialog = false;
    },
    loadPreset(preset) {
      this.$emit("loadPreset", preset);
      this.closeMenu();
    },
    showDeleteDialog(preset) {
      this.presetToDelete = preset;
      this.deleteDialog = true;
    },
    ...mapActions({
      deleteFilterPreset: "filterPreset/delete",
    }),
  },
  props: {
    buttonText: {
      type: String,
      default: "Load Filters",
    },
    filterList: {
      required: true,
      type: Array,
    },
    presetList: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style></style>
